<template lang="pug">
    .modal-analise-solicitacao
        collapse-component.collapse(
            v-for='(solicitacao, i) in solicitacoes',
            :key='i',
            :title='solicitacao.codigoImovel'
        )
            .modal-content
                div
                    b CAR: 
                    span {{ solicitacao.codigoImovel }}
                div
                    b Nome do imóvel: 
                    span {{ solicitacao.nomeImovel }}
                div
                    b Condição: 
                    span {{ getCondicaoInscricaoLabel(solicitacao.condicaoInscricao) }}
                div
                    b Justificativa: 
                    span {{ solicitacao.justificativa }}
        .acoes
            b Resultado da análise:
            radio-button-component(
                ref='analiseCheckbox'
                v-model='form.resultado',
                :list='aprovadoOptions',
                :disabled='modoLeitura',
            )
            b Parecer do analista:
            text-area-input-component(v-model='form.parecer', :disabled='modoLeitura')
        .rodape(v-if='!modoLeitura')
            button-component.botao-cancelar(label='Cancelar', icon='mdi-close', @click.native='$emit("close")')
            button-component(label='Finalizar', icon='mdi-check', @click.native='finalizarAnalise')
</template>

<script>
import { salvarAnaliseSolicitacao } from '@/services/solicitacao-envio-monitoramento.service';
import { CondicaoInscricaoEnum } from '@/enums/processo.enum';

export default {
    name: 'ModalAnaliseSolicitacao',
    props: {
        solicitacoes: {
            type: Array,
            required: true,
            default: () => [],
        },
        modoLeitura: {
            type: Boolean,
            default: false
        },
    },
    mounted() {
        if (this.modoLeitura) {
            this.form.parecer = this.solicitacoes[0].parecer;
            this.form.resultado = this.solicitacoes[0].condicao;

            this.aplicarCheckInicial();
        }
    },
    data() {
        return {
            form: {
                parecer: null,
                resultado: null
            },
            aprovadoOptions: [
                { id: 'APROVADO', label: 'Aprovado', checked: false },
                { id: 'REPROVADO', label: 'Reprovado', checked: false },
            ]
        };
    },
    methods: {
        aplicarCheckInicial() {
            this.aprovadoOptions.forEach(opt => {
                opt.checked = (opt.id === this.form.resultado);
            });
        },
        async finalizarAnalise() {
            if (!this.form.parecer || this.form.parecer === '') {
                this.$notify({
                    title: 'Erro!',
                    message: 'Por favor, informe o parecer do analista.',
                    showClose: true,
                    type: 'error'
                });
                return;
            }

            if (!this.form.resultado) {
                this.$notify({
                    title: 'Erro!',
                    message: 'Por favor, selecione o resultado da análise: Aprovado ou Reprovado.',
                    showClose: true,
                    type: 'error'
                });
                return;
            }
            
            try {
                this.form.idsSolicitacao = this.solicitacoes.map(s => s.id);

                await salvarAnaliseSolicitacao(this.form);

                this.$emit('close');
                this.$emit('atualizar');

                this.$notify({
                    title: 'Sucesso!',
                    message: 'A análise foi finalizada com sucesso!',
                    showClose: true,
                    type: 'success'
                });
            } catch (error) {
                this.$notify({
                    title: 'Erro!',
                    message: 'Ocorreu um erro ao tentar finalizar a análise.',
                    showClose: true,
                    type: 'error'
                });
            }
        },
        getCondicaoInscricaoLabel(idCondicaoInscricao) {
            const condicaoInscricao = Object.values(CondicaoInscricaoEnum).find(item => item.id === idCondicaoInscricao);
            return condicaoInscricao ? condicaoInscricao.label : 'Desconhecido';
        },
    }
};
</script>

<style scoped>
.modal-analise-solicitacao {
    margin: 30px 10px 20px 10px !important;
    max-height: calc(100vh - 200px) !important;
    overflow-y: auto;
}

.modal-content {
    line-height: 30px;
}

.collapse {
    margin-bottom: 20px;
}

.rodape {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

.botao-cancelar {
    background-color: #ddd !important;
    color: #666 !important;
}
</style>